import { render, staticRenderFns } from "./ClaimStatusChart.vue?vue&type=template&id=2935dcdf&"
import script from "./ClaimStatusChart.vue?vue&type=script&lang=js&"
export * from "./ClaimStatusChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports